module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/how-to-rsvp-to-a-wedding-e1f6d523e9477b8be5bb6418f67881d4.jpg";